import React from 'react';
import cn from 'classnames';
/* Components */
import {LoaderComponent} from 'src/components/Loader';

import styles from './thumbnailDisplay.styles.scss';
import PropTypes from 'prop-types';

const ThumbnailPreload = ({className, thumbnailClassName}) => {
  return (
    <div className={cn(styles.thumbnail, className, thumbnailClassName)}>
      <div className={styles.thumbnailContent}>
          <div>
            <LoaderComponent />
          </div>
        <div className={styles.thumbnailOverlay} />
        <div className={styles.thumbnailButtonContainer} />
      </div>
    </div>
  );
};

ThumbnailPreload.propTypes = {
  className: PropTypes.string,
  thumbnailClassName: PropTypes.string,
};

export default ThumbnailPreload;
